import { AttentionButton } from "views/components/AttentionButton";
import { ColumnSpacer } from "../common/ColumnSpacer";
import { ExistingReservationWrapper } from "views/components/ExistingReservationWrapper";
import { LineInfoContainer } from "views/components/LineInfoContainer";
import { Spacer } from "views/components/common/Spacer";
import { getWaitStimated } from "lib/getWaitStimated";
import { pathOr } from "ramda";
import {
	selectUserReservationByLine,
	selectUserReservationByOffice,
} from "state/tickets/selectors";
import { useAuth } from "hooks/useAuth";
import { useGetForms } from "hooks/useGetForms";
import { useHistory } from "react-router";
import { useTimeAndPeopleAhead } from "hooks/useTimeAndPeopleAhead";
import React, { useGlobal } from "reactn";
import styled from "styled-components";

export const TicketDetail = ({
	attention_type,
	navigateToTicketScreen,
	office,
	line,
	ticket,
	onReservationClick,
	onTicketClick,
	ticketLabel,
	loading,
	ticketDisabled,
	reservationDisabled,
	quota,
	v2,
	webOnly,
	enabledReservations,
	restrictions,
}) => {
	const [habilityTicketAndReservation] = useGlobal("habilityTicketAndReservation");
	const { isLoggedInTemporary } = useAuth();
	const history = useHistory();
	const [reservations] = useGlobal("myReservations");
	const {
		realPeopleAhead,
		wait,
		loading: loadingWait,
	} = useTimeAndPeopleAhead(line, office);
	const reservation = selectUserReservationByLine(
		reservations.byId,
		line.slug
	);
	const getForms = useGetForms({
		officeId: office && office.id,
		lineId: line && line.id,
		isTicket: true,
	});

	const userRestrictions = pathOr(null, ["userRestrictions"], restrictions);
	const { call = {} } = line || {};
	const avgElapsed = pathOr(0, ["raw_tickets", "avg_elapsed", "mean"], line);
	const currentWaitingTicket = call;
	const attentionTypeTicket = pathOr(
		true,
		["options", "attention_type", "tickets"],
		office
	);
	const attentionTypeReserve = pathOr(
		true,
		["options", "attention_type", "reservations"],
		office
	);
	const lineFrozen = pathOr(false, ["frozen"], line);

	const virtualRoom = pathOr(false, ["options", "virtualRoom"], office);

	const isWaitingTicket =
		!!currentWaitingTicket?.prefix && !!currentWaitingTicket?.number;
	const reservationByOffice = selectUserReservationByOffice(
		reservations.byId,
		office.slug
	);

	const waitingTicket =
		call && call?.prefix !== null
			? `${call?.prefix}${call?.number}`
			: "N/A";
	const suggestion = (() => {
		if (v2) {
			if (isWaitingTicket && !ticket && !!quota) {
				return `Puedes tomar un ticket o reservar una hora de ${quota} cupo(s) disponible(s):`;
			}
			if (isWaitingTicket && !!ticket && !!quota) {
				return `Puedes reservar una hora de ${quota} cupo(s) disponible(s):`;
			}
			if (!!ticket || ticketDisabled) {
				return `También puedes reservar una hora:`;
			}
			return `Puedes tomar un ticket o reservar una hora:`;
		}
		return false;
	})();

	const goToLogin = () =>
		history.push("/signin", {
			from: history.location.pathname,
		});

	const realWaitStimated =
		wait && wait > 0
			? Math.min(Number(wait), 180) === 180
				? `+${Math.min(Number(wait), 180)}`
				: Math.min(Number(wait), 180) || "-"
			: loadingWait
			? "-"
			: getWaitStimated(realPeopleAhead, avgElapsed);

	const styles = reservation
		? { display: "flex", alignItems: "center", justifyContent: "center" }
		: { display: "flex", justifyContent: "center" };

	const enableButtonByRestrictions = () => {
		if (userRestrictions === null) {
			return false;
		}
		if (
			userRestrictions === "office" &&
			reservationByOffice &&
			reservationByOffice.id
		) {
			return true;
		}
		if (userRestrictions === "enterprise") {
			if (
				(reservation && !reservation.deleted) ||
				(reservationByOffice &&
					reservationByOffice.id &&
					!reservationByOffice.deleted)
			) {
				return true;
			}
		}
		if (
			userRestrictions === "line" &&
			reservation &&
			reservation.line_id === line.id
		) {
			return true;
		}
		if (!restrictions) {
			if (reservation && !reservation.deleted) {
				return true;
			}
		}
	};
	return (
		<>
			<TicketDetailWrapper>
				{virtualRoom && (
					<>
						{ticket ? (
							<>
								<p className="virtualRoom_text">
									Estás en la fila virtual
								</p>
							</>
						) : (
							<>
								<p className="virtualRoom_text">
									Atención por videollamada
								</p>
								<span className="virtualRoom__helper-text">
									Únete a la fila virtual para hablar con un
									asesor por videollamada
								</span>
							</>
						)}
					</>
				)}

				<div>
					{attentionTypeTicket && (
						<LineInfoContainer
							realWaitStimated={realWaitStimated}
							call={call}
							peopleAhead={realPeopleAhead}
							waitingTicket={waitingTicket}
							virtualRoom={virtualRoom}
							desktop
						/>
					)}
					<Spacer rows={0.5} />
				</div>
				{reservation && (
					<>
						<Spacer rows={0.5} />
						<ExistingReservationWrapper
							reservation={reservation}
							isLoggedInTemporary={isLoggedInTemporary}
							desktop
						/>
						<Spacer rows={0.5} />
					</>
				)}
				<ButtonsAttentionContainer style={styles}>
					{attentionTypeTicket &&
						(!enabledReservations || !attentionTypeReserve) && (
							<Card>
								<AttentionButton
									type={"tickets"}
									isDisabled={loading || ticketDisabled || habilityTicketAndReservation?.ticket}
									onClick={onTicketClick}
									loading={loading}
									ticket={ticket}
									navigateToTicketScreen={
										navigateToTicketScreen
									}
									virtualRoom={virtualRoom}
									desktop
								/>
								<ContentHelp>
									<SubtitleHelp>
										<span>Con el ticket virtual,</span>{" "}
										podrás seguir el tiempo de espera,
										personas en fila y saber cuando sea tu
										turno
									</SubtitleHelp>
								</ContentHelp>
							</Card>
						)}
					{!attentionTypeTicket &&
						(enabledReservations || attentionTypeReserve) && (
							<Card>
								<ContentHelp>
									<TitleHelp>
										¡Queremos ahorrarte tiempo!
									</TitleHelp>
									<SubtitleHelp>
										Elige el día y la hora que prefieras
										para realizar tu trámite
									</SubtitleHelp>
								</ContentHelp>
								<AttentionButton
									attention_type={attention_type}
									type="reservations"
									isDisabled={
										reservationDisabled ||
										enableButtonByRestrictions() ||
										habilityTicketAndReservation?.reservation
									}
									reservation={reservation ? true : false}
									onClick={onReservationClick}
									virtualRoom={virtualRoom}
								/>
							</Card>
						)}
					{attentionTypeTicket &&
						attentionTypeReserve &&
						enabledReservations && (
							<>
								<AttentionButton
									type={"tickets"}
									isDisabled={loading || ticketDisabled || habilityTicketAndReservation?.ticket}
									onClick={onTicketClick}
									loading={loading}
									ticket={ticket}
									navigateToTicketScreen={
										navigateToTicketScreen
									}
									virtualRoom={virtualRoom}
									lineFrozen={lineFrozen}
									desktop
								/>
								<ColumnSpacer column={10} />
								<AttentionButton
									attention_type={attention_type}
									type="reservations"
									isDisabled={
										reservationDisabled ||
										enableButtonByRestrictions() ||
										habilityTicketAndReservation?.reservation
									}
									reservation={reservation ? true : false}
									onClick={onReservationClick}
									virtualRoom={virtualRoom}
								/>
							</>
						)}
				</ButtonsAttentionContainer>
			</TicketDetailWrapper>
		</>
	);
};

const ButtonsAttentionContainer = styled.div`
	width: 100%;
	@media (max-width: 1080px) {
		flex-direction: column;
	}
`;

const TicketDetailWrapper = styled.div`
	width: 100%;
	max-width: 100%;
	.videocall__description {
		width: 100%;
		box-shadow: 0px 8px 16px -6px #18274b14;
		display: flex;
		padding: 8px;
		font-weight: 400;
	}
	.videocall__description-text {
		width: 45%;
		h5 {
			font-size: 14px;
			font-weight: 500;
		}
		margin-right: 5%;
	}
	.virtualRoom_text {
		font-weight: 600;
		font-size: 16px;
	}
`;

const Card = styled.div`
	width: 85%;
	padding: 15px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12),
		0px 8px 16px -6px rgba(24, 39, 75, 0.08);
	border-radius: 8px;
`;

const TitleHelp = styled.p`
	margin-bottom: 4px;
	font-weight: 500;
	font-size: 14px;
	line-height: 22px;
`;

const SubtitleHelp = styled.span`
	font-size: 14px;
	line-height: 22px;
	font-weight: 400;
	& > span {
		font-weight: 500;
	}
`;

const ContentHelp = styled.div`
	width: 45%;
`;
